import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { ToastService } from '@app/shared/services/toast/toast.service';
import { AuthService } from '@app/shared/auth/auth.service';
import { ApiConfigService } from '@app/app.config';
import { LoginResponseInterface } from '@app/login/login.interface';
import { ConfigService } from '@app/shared/auth/config.service';
import { CurrencyService } from '@app/shared/services/currency/currency.service';
import { HTTP_CODES } from '../shared/constants/httpCodes';

@Injectable()
export class LoginService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly apiConfig: ApiConfigService,
    private readonly configService: ConfigService,
    private readonly currencyService: CurrencyService,
    private readonly localStorageService: LocalStorageService,
  ) {
  }

  public signIn(body: { email: string; password: string }): Observable<void> {
    return this.httpClient
      .post<LoginResponseInterface>(this.apiConfig.loginUrl(''), body)
      .pipe(
        map(response => {
          this.authService.user = response.user;
          this.authService.token = response.token;
          this.configService.fetchClientConfig('growth').then(() => {
            this.currencyService.loadUserCurrency().then(() => {
              this.router.navigate(['home']);
            });
          });
        }),
        catchError((error: HttpErrorResponse) => {
          if (error.status === HTTP_CODES.unauthorized) {
            if (error.error.code === 3) {
              this.toastService.showError('You do not have permission to view benchmarks.', 'Please contact support to solve the issue.');
            } else if (error.error.code === 2) {
              this.toastService.showError('You do not have permission to view benchmarks.', 'Please contact support for more details.');
            } else {
              this.toastService.showError('Invalid user name or password!');
            }
          } else if (error.status === HTTP_CODES.badRequest
            || error.status === HTTP_CODES.unprocessableEntity
            || error.status === HTTP_CODES.notFound) {
            this.toastService.showError('Invalid user name or password!');
          }
          return EMPTY;
        }),
      );
  }

  public signOut(): void {
    this.authService.invalidateUser();
    this.localStorageService.invalidateToken();
    this.localStorageService.invalidateCurrency();
    this.configService.cleanup();
    this.authService.invalidateUser();
    sessionStorage.removeItem('NAVIGATION_KEY');
    window.location.href = 'login';
  }
}
